export default __webpack_public_path__ + "static/media/mail.d2fd9dcf.svg";